import { SHOW_BID_DETAILS } from 'actionTypes/bidDetailsActionTypes';

export const setBidDetails = (payload) => ({
  type: SHOW_BID_DETAILS,
  payload,
});

export default {
  setBidDetails,
};
